"use client";

import React, { useMemo } from "react";
import { TrendingUp, TrendingDown, Minus, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
const trendingNamesData = [{
  id: "n1",
  name: "Aaliyah",
  trend: "up",
  rank: 15
}, {
  id: "n2",
  name: "Aaron",
  trend: "stable",
  rank: 42
}, {
  id: "n3",
  name: "Abigail",
  trend: "down",
  rank: 8
}, {
  id: "n4",
  name: "Asher",
  trend: "up",
  rank: 3
}, {
  id: "n5",
  name: "Aurora",
  trend: "up",
  rank: 1
}, {
  id: "n6",
  name: "Benjamin",
  trend: "stable",
  rank: 9
}, {
  id: "n7",
  name: "Brooks",
  trend: "up",
  rank: 77
}, {
  id: "n8",
  name: "Caleb",
  trend: "down",
  rank: 55
}, {
  id: "n9",
  name: "Charlotte",
  trend: "up",
  rank: 4
}, {
  id: "n10",
  name: "Chloe",
  trend: "stable",
  rank: 22
}, {
  id: "n11",
  name: "Daniel",
  trend: "down",
  rank: 16
}, {
  id: "n12",
  name: "Delilah",
  trend: "up",
  rank: 60
}, {
  id: "n13",
  name: "Elijah",
  trend: "stable",
  rank: 5
}, {
  id: "n14",
  name: "Emma",
  trend: "down",
  rank: 2
}, {
  id: "n15",
  name: "Ezra",
  trend: "up",
  rank: 25
}, {
  id: "n16",
  name: "Felix",
  trend: "up",
  rank: 88
}, {
  id: "n17",
  name: "Freya",
  trend: "up",
  rank: 91
}, {
  id: "n18",
  name: "Gabriel",
  trend: "stable",
  rank: 33
}, {
  id: "n19",
  name: "Gianna",
  trend: "up",
  rank: 12
}, {
  id: "n20",
  name: "Henry",
  trend: "stable",
  rank: 7
}, {
  id: "n21",
  name: "Harper",
  trend: "down",
  rank: 10
}, {
  id: "n22",
  name: "Isabella",
  trend: "stable",
  rank: 6
}, {
  id: "n23",
  name: "Isaac",
  trend: "down",
  rank: 40
}, {
  id: "n24",
  name: "Liam",
  trend: "up",
  rank: 2
}, {
  id: "n25",
  name: "Noah",
  trend: "stable",
  rank: 1
}, {
  id: "n26",
  name: "Oliver",
  trend: "up",
  rank: 3
}, {
  id: "n27",
  name: "James",
  trend: "down",
  rank: 4
}, {
  id: "n28",
  name: "William",
  trend: "stable",
  rank: 5
}, {
  id: "n29",
  name: "Sophia",
  trend: "up",
  rank: 1
}, {
  id: "n30",
  name: "Olivia",
  trend: "stable",
  rank: 2
}, {
  id: "n31",
  name: "Amelia",
  trend: "up",
  rank: 3
}, {
  id: "n32",
  name: "Evelyn",
  trend: "down",
  rank: 9
}, {
  id: "n33",
  name: "Luna",
  trend: "up",
  rank: 11
}, {
  id: "n34",
  name: "Theodore",
  trend: "up",
  rank: 10
}, {
  id: "n35",
  name: "Levi",
  trend: "up",
  rank: 12
}, {
  id: "n36",
  name: "Sebastian",
  trend: "stable",
  rank: 13
}, {
  id: "n37",
  name: "Jack",
  trend: "up",
  rank: 14
}, {
  id: "n38",
  name: "Owen",
  trend: "down",
  rank: 18
}, {
  id: "n39",
  name: "Wyatt",
  trend: "stable",
  rank: 20
}, {
  id: "n40",
  name: "Leo",
  trend: "up",
  rank: 21
}, {
  id: "n41",
  name: "Julian",
  trend: "up",
  rank: 23
}, {
  id: "n42",
  name: "Hudson",
  trend: "up",
  rank: 24
}, {
  id: "n43",
  name: "Grayson",
  trend: "down",
  rank: 26
}, {
  id: "n44",
  name: "Maverick",
  trend: "up",
  rank: 27
}, {
  id: "n45",
  name: "Mateo",
  trend: "up",
  rank: 28
}, {
  id: "n46",
  name: "Gabriel",
  trend: "stable",
  rank: 29
}, {
  id: "n47",
  name: "Carter",
  trend: "down",
  rank: 30
}, {
  id: "n48",
  name: "Waylon",
  trend: "up",
  rank: 31
}, {
  id: "n49",
  name: "Silas",
  trend: "up",
  rank: 32
}, {
  id: "n50",
  name: "Ezra",
  trend: "stable",
  rank: 33
}, {
  id: "n51",
  name: "Miles",
  trend: "up",
  rank: 34
}, {
  id: "n52",
  name: "Luca",
  trend: "up",
  rank: 35
}, {
  id: "n53",
  name: "Rowan",
  trend: "up",
  rank: 36
}, {
  id: "n54",
  name: "Enzo",
  trend: "up",
  rank: 37
}, {
  id: "n55",
  name: "Arlo",
  trend: "up",
  rank: 38
}, {
  id: "n56",
  name: "Milo",
  trend: "up",
  rank: 39
}, {
  id: "n57",
  name: "Atlas",
  trend: "up",
  rank: 40
}, {
  id: "n58",
  name: "Theo",
  trend: "up",
  rank: 41
}, {
  id: "n59",
  name: "Arthur",
  trend: "up",
  rank: 42
}, {
  id: "n60",
  name: "Otto",
  trend: "up",
  rank: 43
}, {
  id: "n61",
  name: "Hugo",
  trend: "up",
  rank: 44
}, {
  id: "n62",
  name: "Felix",
  trend: "up",
  rank: 45
}, {
  id: "n63",
  name: "Jasper",
  trend: "up",
  rank: 46
}, {
  id: "n64",
  name: "Jude",
  trend: "up",
  rank: 47
}, {
  id: "n65",
  name: "Kai",
  trend: "up",
  rank: 48
}, {
  id: "n66",
  name: "Koa",
  trend: "up",
  rank: 49
}, {
  id: "n67",
  name: "Lachlan",
  trend: "up",
  rank: 50
}, {
  id: "n68",
  name: "Magnus",
  trend: "up",
  rank: 51
}, {
  id: "n69",
  name: "Nico",
  trend: "up",
  rank: 52
}, {
  id: "n70",
  name: "Otis",
  trend: "up",
  rank: 53
}, {
  id: "n71",
  name: "Phineas",
  trend: "up",
  rank: 54
}, {
  id: "n72",
  name: "Quinn",
  trend: "up",
  rank: 55
}, {
  id: "n73",
  name: "Remy",
  trend: "up",
  rank: 56
}, {
  id: "n74",
  name: "Soren",
  trend: "up",
  rank: 57
}, {
  id: "n75",
  name: "Viggo",
  trend: "up",
  rank: 58
}, {
  id: "n76",
  name: "Wilder",
  trend: "up",
  rank: 59
}, {
  id: "n77",
  name: "Zev",
  trend: "up",
  rank: 60
}];
export default function CurrentTopTrends() {
  const letters = useMemo(() => {
    const uniqueLetters = new Set(trendingNamesData.map(n => n.name.charAt(0).toUpperCase()));
    return Array.from(uniqueLetters).sort();
  }, []);
  return <section id="current-top-trends" className="bg-background py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-bold tracking-tight text-primary sm:text-4xl mb-4">
              Current Top Trends
            </h2>
            <p className="text-lg text-foreground/80">
              Discover the latest names gaining popularity in the naming world. 
              Our real-time directory tracks which names are rising, falling, or holding steady.
            </p>
          </div>
          <div className="shrink-0">
            <Button asChild variant="default" className="rounded-lg bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground transition-colors">
              <Link to="/TrendingPage">
                View Full Trending List
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="relative">
          {letters.map((letter, index) => <div key={letter} data-index={index} className="mb-12 last:mb-0">
              
              <div className="sticky top-0 z-10 bg-background/95 backdrop-blur-md py-3 border-b border-border/50 mb-6">
                <h3 className="text-2xl font-bold text-primary px-2">
                  {letter}
                </h3>
              </div>

              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
                {trendingNamesData.filter(item => item.name.charAt(0).toUpperCase() === letter).map((item, itemIndex) => {
              const isTop10 = item.rank <= 10;
              return <div key={item.id} data-index={itemIndex} className="h-full">
                        <Card className={cn("h-full py-0 transition-all duration-200 hover:-translate-y-1 hover:shadow-md rounded-lg border", isTop10 ? "bg-accent/20 border-accent/40 shadow-sm" : "bg-card border-border/30")}>
                          <CardContent className="p-4 sm:p-5 flex items-center justify-between gap-3 h-full">
                            <div className="flex flex-col min-w-0">
                              <span className="font-bold text-lg text-primary truncate">
                                {item.name}
                              </span>
                              <span className="text-sm text-muted-foreground mt-0.5">
                                Rank #{item.rank}
                              </span>
                            </div>
                            
                            <div className="flex flex-col items-end gap-2 shrink-0">
                              {item.trend === "up" && <TrendingUp className="w-5 h-5 text-emerald-600" aria-label="Trending Up" />}
                              {item.trend === "down" && <TrendingDown className="w-5 h-5 text-rose-600" aria-label="Trending Down" />}
                              {item.trend === "stable" && <Minus className="w-5 h-5 text-slate-400" aria-label="Stable" />}
                              
                              {isTop10 && <Badge variant="outline" className="rounded-lg text-[10px] px-1.5 py-0 h-5 uppercase tracking-wider border-accent text-accent-foreground bg-background/50 font-semibold">
                                  Top 10
                                </Badge>}
                            </div>
                          </CardContent>
                        </Card>
                      </div>;
            })}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}